// import { text } from "framer-motion/client";
import React, { useMemo, useState } from "react";

// const SERVICES = [
//   "Site development",
//   "Stormwater management",
//   "Feasibility & Environmental",
//   "Topographic Surveys",
//   "Floodplain feasibility Analysis",
// ];
const ENTITLEMENT = [
  {risk:"Zoning/Use & Density Fit",txt:"By-right vs. special use/conditional use, FAR/lot coverage/height/setbacks, use table fit and proffers/overlays, ADU rules, parking ratios"},
  {risk:"Rezoning/Special Use Feasibility",txt:"Likelihood, precedent, comp plan alignment. Proffer strategy, timelines, hearing bodies."},
  {risk:"Subdivision & Platting",txt:"Lot yield, frontage, access, minimums. Preliminary/final plat risks and sequencing."},
  {risk:"Stormwater & Drainage (SWM/ESC)",txt:"Lot yield, frontage, access, minimums. Preliminary/final plat risks and sequencing."},
  {risk:"Environmental & Chesapeake Bay/Wetlands",txt:"RPA/RMA impacts, buffers, JPA needs. Wetland delineation risk, mitigation pathways."},
  {risk:"Utilities & Capacity",txt:"Water/sewer availability & pro-rata fees. Easements, relocations, dry utilities conflicts."},
  {risk:"Floodplain / Coastal / Sea-Level",txt:"FEMA, freeboard, compensatory storage, coastal overlays."},
  {risk:"Septic / Well (On-site systems)",txt:"Soil suitability, setbacks, reserve area feasibility"},
  {risk:"Violations",txt:""},
  {risk:"Right-of-Way / Easements / Off-Site",txt:"Dedications, acquisitions, neighbor consents"},

]
export default function StepForm() {
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    services: [],
  });
  const [errors, setErrors] = useState({});

  const steps = useMemo(
    () => [
      { id: 0, title: "Your info" },
      { id: 1, title: "Entitlement Risks" },
      { id: 2, title: "Review & Send" },
    ],
    []
  );
  const isFinal = step === steps.length - 1;
  const onChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "services[]") {
      setForm((f) => {
        const next = checked
          ? [...f.services, value]
          : f.services.filter((v) => v !== value);
        return { ...f, services: next };
      });
      return;
    }

    setForm((f) => ({ ...f, [name]: type === "tel" ? value.trim() : value }));
  };

  const validate = (currentStep) => {
    const err = {};
    if (currentStep === 0) {
      if (!form.fullName) err.fullName = "Your name is required.";
      if (!form.email) err.email = "Email is required.";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
        err.email = "Enter a valid email.";
      if (!form.phone) err.phone = "Contact number is required.";
      else if (!/^[0-9+\-()\s]{7,}$/.test(form.phone))
        err.phone = "Enter a valid phone number.";
    }
    if (currentStep === 1) {
      if (form.services.length === 0)
        err.services = "Select at least one entitlement risk.";
    }
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = (e) => {
    if (!isFinal) {
      e.preventDefault();
      if (validate(step)) setStep((s) => s + 1);
      return;
    }
    if (!validate(step)) e.preventDefault();
  };

  const handleKeyDown = (e) => {
    if (!isFinal && e.key === "Enter") e.preventDefault();
  };

  return (
    <div className="h-auto w-full max-w-4xl mx-auto text-gray-100 flex items-center justify-center py-8 sm:py-12 md:py-16 px-4 sm:px-6">
      <form
        onSubmit={handleSubmit}
        onKeyDown={handleKeyDown}
        action={
          isFinal ? "https://formsubmit.co/info@innovativeld.com" : undefined
        }
        method={isFinal ? "POST" : undefined}
        className="w-full bg-gray-800/60 backdrop-blur rounded-2xl shadow-xl border border-gray-700 overflow-hidden"
      >
        {/* FormSubmit (se usan solo en el POST final) */}
        {isFinal && (
          <>
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />
            <input
              type="hidden"
              name="_subject"
              value="New Entitlement Risk Scan request"
            />
            <input type="hidden" name="_next" value="https://innovativeld.com/thanks" />
            <input className="hidden" type="text" name="_honey" />
          </>
        )}

        {/* Progress */}
        <div className="px-4 sm:px-6 pt-6 pb-2">
          <ol className="flex items-center justify-between gap-2 sm:gap-3">
            {steps.map((s, i) => {
              const active = i <= step;
              return (
                <li key={s.id} className="flex-1 flex items-center min-w-0">
                  <span
                    className={`flex p-4 h-8 w-8 sm:h-9 sm:w-9 md:h-10 md:w-10 items-center justify-center rounded-full border text-sm sm:text-base md:text-lg font-semibold ${
                      active
                        ? "bg-secundario text-primario border-secundario"
                        : "bg-gray-800 border-gray-600 text-gray-400"
                    }`}
                  >
                    {i + 1}
                  </span>
                  {i < steps.length - 1 && (
                    <span
                      className={`mx-1 sm:mx-2 h-1 w-full rounded ${
                        i < step ? "bg-secundario" : "bg-gray-700"
                      }`}
                    />
                  )}
                </li>
              );
            })}
          </ol>
          <h2 className="mt-3 sm:mt-4 text-xl sm:text-2xl md:text-4xl font-bold text-secundario">
            {steps[step].title}
          </h2>
        </div>

        {/* STEP 1 */}
        <fieldset className={step === 0 ? "block" : "hidden"}>
          <div className="grid gap-5 p-5 sm:p-6 md:p-8 grid-cols-1 md:grid-cols-2">
            <div className="md:col-span-2">
              <label className="block text-sm sm:text-base md:text-lg mb-1">Full name</label>
              <input
                className={`w-full rounded-xl bg-gray-900 border px-4 py-3 outline-none focus:ring-2 focus:ring-secundario text-secundario placeholder:text-secundario/60 ${
                  errors.fullName ? "border-red-500" : "border-gray-700"
                }`}
                name="fullName"
                value={form.fullName}
                onChange={onChange}
                placeholder="John Doe"
                required
              />
              {errors.fullName && (
                <p className="text-red-400 text-sm sm:text-base mt-1">{errors.fullName}</p>
              )}
            </div>

            <div>
              <label className="block text-sm sm:text-base md:text-lg mb-1">Email</label>
              <input
                type="email"
                className={`w-full rounded-xl bg-gray-900 border px-4 py-3 outline-none focus:ring-2 focus:ring-secundario text-secundario placeholder:text-secundario/60 ${
                  errors.email ? "border-red-500" : "border-gray-700"
                }`}
                name="email"
                value={form.email}
                onChange={onChange}
                placeholder="you@email.com"
                required
              />
              {errors.email && (
                <p className="text-red-400 text-sm sm:text-base mt-1">{errors.email}</p>
              )}
            </div>

            <div>
              <label className="block text-sm sm:text-base md:text-lg mb-1">Contact number</label>
              <input
                type="tel"
                className={`w-full rounded-xl bg-gray-900 border px-4 py-3 outline-none focus:ring-2 focus:ring-secundario text-secundario placeholder:text-secundario/60 ${
                  errors.phone ? "border-red-500" : "border-gray-700"
                }`}
                name="phone"
                value={form.phone}
                onChange={onChange}
                placeholder="+1 555 123 4567"
                required
              />
              {errors.phone && (
                <p className="text-red-400 text-sm sm:text-base mt-1">{errors.phone}</p>
              )}
            </div>
          </div>
        </fieldset>

        {/* STEP 2 */}
        <fieldset className={step === 1 ? "block" : "hidden"}>
          <div className="p-5 sm:p-6 md:p-8">
            <p className="text-sm sm:text-base md:text-lg text-gray-300 mb-3">
              What type of entitlement risks do you need?
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              
              {ENTITLEMENT.map((item,i) => (
                <label
                  key={i}
                  className={`flex items-center gap-3 rounded-xl border px-4 py-3 cursor-pointer transition text-sm sm:text-base ${
                    form.services.includes(item.risk)
                      ? "border-secundario bg-secundario/10"
                      : "border-gray-700 hover:border-gray-500"
                  }`}
                >
                  <input
                    type="checkbox"
                    name="services[]"
                    value={item.risk}
                    checked={form.services.includes(item.risk)}
                    onChange={onChange}
                    className="h-5 w-5 accent-secundario"
                  />
                  <div className="flex flex-col gap-2 w-[90%]">
                    <span className="leading-tight font-bold font-primaria text-secundario">{item.risk}</span>
                    {item.txt ? 
                      <span className="text-sm">{item.txt ? item.txt : ""}</span>
                    :
                     ""
                    }
                  </div>
                </label>
              ))}
            </div>
            {errors.services && (
              <p className="text-red-400 text-sm sm:text-base mt-3">{errors.services}</p>
            )}
          </div>
        </fieldset>

        {/* STEP 3 */}
        <fieldset className={step === 2 ? "block" : "hidden"}>
          <div className="p-5 sm:p-6 md:p-8 space-y-4">
            <h3 className="text-lg sm:text-xl font-semibold">Review</h3>
            <div className="grid gap-3">
              <InfoRow label="Name" value={form.fullName} />
              <InfoRow label="Email" value={form.email} />
              <InfoRow label="Phone" value={form.phone} />
              <InfoRow
                label="Services"
                value={
                  form.services.length
                    ? form.services.join(", ")
                    : "No services selected"
                }
              />
            </div>
            <p className="text-xs sm:text-sm text-gray-400">
              By submitting, you agree to be contacted regarding your inquiry.
            </p>
          </div>
        </fieldset>

        {/* Controls */}
        <div className="px-4 sm:px-6 pb-6 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4 sm:justify-between">
          <button
            type="button"
            onClick={() => setStep((s) => Math.max(s - 1, 0))}
            disabled={step === 0}
            className="w-full sm:w-auto px-5 sm:px-6 md:px-8 py-2 rounded-full border border-gray-600 text-gray-200 disabled:opacity-40 hover:bg-gray-700"
          >
            Back
          </button>

          <button
            type="submit"
            className="w-full sm:w-auto px-5 sm:px-6 md:px-8 py-2 rounded-full bg-gray-400 text-primario font-semibold hover:bg-secundario"
          >
            {isFinal ? "Send" : "Next"}
          </button>
        </div>
      </form>
    </div>
  );
}

function InfoRow({ label, value }) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between bg-gray-900 border border-gray-700 rounded-xl px-4 py-3 gap-2 sm:gap-5">
      <span className="text-secundario text-sm sm:text-base">{label}</span>
      <span className="font-medium text-white text-left sm:text-right text-sm sm:text-base">
        {value}
      </span>
    </div>
  );
}
